
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { PageLayout } from '@/components/layout/PageLayout';
import { useDashboardData } from '@/hooks/use-dashboard-data';
import { useAuth } from '@/contexts/AuthContext';
import { StatCards } from '@/components/dashboard/StatCards';
import { WorkoutCard } from '@/components/dashboard/WorkoutList';
import { ActivityCard } from '@/components/dashboard/ActivityList';

const Dashboard = () => {
  const { user } = useAuth();
  const { data, isLoading, error } = useDashboardData();
  
  // Get user's first name if available
  const firstName = user?.user_metadata?.first_name || 'Back';
  
  // Get current month for the welcome message
  const currentMonth = new Date().toLocaleString('default', { month: 'long' });

  // Handle error state
  if (error) {
    console.error('Dashboard data error:', error);
  }

  return (
    <PageLayout className="bg-background">
      <div className="container mx-auto px-4 py-6 md:py-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
          <div>
            <h1 className="text-3xl font-bold font-lexend">Welcome {firstName}</h1>
            <p className="text-muted-foreground">Your AI training dashboard for {currentMonth}</p>
          </div>
          <Button asChild>
            <Link to="/workout">
              Start Today's Workout
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>

        <StatCards isLoading={isLoading} data={data} />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <WorkoutCard 
            isLoading={isLoading} 
            workouts={data?.upcomingWorkouts ?? []} 
          />
          
          <ActivityCard 
            isLoading={isLoading} 
            activities={data?.recentActivities ?? []} 
          />
        </div>
      </div>
    </PageLayout>
  );
};

export default Dashboard;
